import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../Designs/trending.css";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";

const Trending = () => {
  const [trend, setTrend] = useState([]);

  useEffect(() => {
    getTrend();
  }, []);

  async function getTrend() {
    const data = await fetch(
      "https://api.themoviedb.org/3/genre/movie/list?api_key=375735221c3b7b45a786c79616eae571&language=en-US"
    );
    const response = await data.json();
    console.log(response.genres, "trending");
    setTrend(response.genres);
  }

  return (
    <div className="genre-box">
      <p className="choose-genre">Choose from your favourite genres</p>
      <ul className="genre-ul">
        <Splide
          options={{
            perPage: 8,
            // type: "loop",
            drag: "free",
            gap: "1rem",
            pagination: false,
            perMove: 1,
            breakpoints: {
              640: {
                perPage: 2,
                width: 400,
                height: 400,
                // pagination: true,
              },
            },
          }}
        >
          {trend.map((movie) => (
            <SplideSlide>
              <Link
                to={`/genre/${movie.id}`}
                key={movie.id}
                className="genre-link"
              >
                <li className="genre-list" style={{ color: "white" }}>
                  {movie.name}
                </li>
              </Link>
            </SplideSlide>
          ))}
        </Splide>
      </ul>
    </div>
  );
};

export default Trending;
